import { render, staticRenderFns } from "./PatientReportForm.vue?vue&type=template&id=05cc89eb&scoped=true"
import script from "./PatientReportForm.vue?vue&type=script&lang=js"
export * from "./PatientReportForm.vue?vue&type=script&lang=js"
import style0 from "./PatientReportForm.vue?vue&type=style&index=0&id=05cc89eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc89eb",
  null
  
)

export default component.exports